export enum SnackbarTypes {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Loading = 'loading',
}
export enum BannerTypes {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  FeatureIntroduction = 'feature-introduction',
}
